// extracted by mini-css-extract-plugin
module.exports = {"spindlLogo":"SpindlLogo_spindlLogo__2PHDH","logo":"SpindlLogo_logo__2BzUu"};